import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import ItemList from 'flarum/common/utils/ItemList';
import Stream from 'flarum/common/utils/Stream';
import FormError from '../form/FormError';
import PollGroupFormState from '../../states/PollGroupFormState';
import PollGroupControls from '../../utils/PollGroupControls';
import PollListItem from '../Poll/PollListItem';
export default class PollGroupForm extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "name", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.state = new PollGroupFormState(this.attrs.pollGroup);
    this.name = Stream(this.state.pollGroup.name() || '');
  }
  view() {
    return m("form", {
      onsubmit: this.onsubmit.bind(this)
    }, m("div", {
      className: "PollGroupModal-form"
    }, this.fields().toArray()));
  }
  fields() {
    const items = new ItemList();
    items.add('name', m("div", {
      className: "Form-group"
    }, m("label", {
      className: "label"
    }, "Name"), m("input", {
      type: "text",
      name: "name",
      className: "FormControl",
      bidi: this.name,
      required: true
    })), 100);
    items.add('submit', m("div", {
      className: "Form-group"
    }, m(Button, {
      type: "submit",
      className: "Button Button--primary PollGroupModal-SubmitButton",
      icon: "fas fa-save",
      loading: this.state.loading
    }, app.translator.trans('fof-polls.forum.poll_groups.composer.save_changes')), this.state.pollGroup.exists && m(Button, {
      className: "Button Button--secondary PollGroupModal-deleteButton",
      icon: "fas fa-trash-alt",
      loading: this.state.deleting,
      onclick: this.delete.bind(this)
    }, app.translator.trans('fof-polls.forum.poll_groups.composer.delete'))));
    if (this.state.pollGroup.exists) {
      const pollItems = this.pollItems().toArray();
      if (pollItems.length > 0) {
        items.add('polls', m("div", {
          className: "PollList"
        }, m("ul", {
          className: "PollList-polls PollGroup-polls"
        }, pollItems)));
      }
      items.add('addPoll', m("div", {
        className: "Form-group"
      }, m(Button, {
        className: "Button Button--primary PollGroupModal-addPollButton",
        icon: "fas fa-plus",
        onclick: () => PollGroupControls.addPoll(this.state.pollGroup)
      }, app.translator.trans('fof-polls.forum.poll_groups.controls.add_poll_label'))));
    }
    return items;
  }
  pollItems() {
    const polls = this.state.pollGroup.polls();
    const items = new ItemList();
    if (!polls || polls.length === 0) {
      return items;
    }
    polls.forEach(poll => {
      if (poll) {
        items.add('poll-' + poll.id(), m("li", {
          key: poll.id(),
          className: "PollGroup-poll"
        }, m(PollListItem, {
          poll: poll
        })));
      }
    });
    return items;
  }
  data() {
    if (!this.name()) {
      throw new FormError('Name cannot be empty');
    }
    return {
      name: this.name()
    };
  }
  async onsubmit(event) {
    event.preventDefault();
    try {
      await this.attrs.onsubmit(this.data(), this.state);
    } catch (error) {
      if (error instanceof FormError) {
        app.alerts.show({
          type: 'error'
        }, error.message);
      } else {
        console.error(error);
        app.alerts.show({
          type: 'error'
        }, 'An error occurred while saving the poll group');
      }
    }
  }
  async delete() {
    await this.state.delete();
  }
}
flarum.reg.add('fof-polls', 'forum/components/PollGroup/PollGroupForm', PollGroupForm);